import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import dayjs from "dayjs";
import "../../App.css";
import { TableLoader } from "../../components/TableLoader";
import { TableNodata } from "../../components/TableNodata";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/client";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useSnackbar } from "../../providers/SnackbarProvider";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const TrainerViewReview = () => {
  const [page, setPage] = useState(+localStorage.getItem("currentPage") || 0);
  const [rowsPerPage, setRowsPerPage] = useState(
    +localStorage.getItem("rowsPerPage") || 10
  );
  const [listData, setListData] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [trainersList, setTrainersList] = useState([]);
  const { showSnackbar } = useSnackbar();
  const [selectedTab, setSelectedTab] = useState(
    +localStorage.getItem("TabValue") || 0
  );
  const [searchKey, setSearchKey] = useState(
    localStorage.getItem("searchvalue") || ""
  );
  const [selectedCollege, setSelectedCollege] = useState(
    +localStorage.getItem("InstituteId") || ""
  );
  const [colleges, setColleges] = useState([]);
  const [selectedTrainer, setSelectedTrainer] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { dashboard } = location.state || "";

  const headers = [
    { label: "S.No", align: "center" },
    ...(localStorage.getItem("role") === "SUPER_ADMIN"
      ? [{ label: "Institute Name", align: "left" }]
      : []),
    { label: "Subject", align: "left" },
    { label: "Level", align: "left" },
    { label: "completed Status", align: "center" },
    { label: "Trainer", align: "left" },
    { label: "Created Date", align: "left" },
    { label: "Actions", align: "center" },
  ];

  // === Fetch Data ===
  const fetchData = async () => {
    setLoading(true);
    try {
      const payload = {
        user_id: selectedTrainer || null,
        page: page,
        size: rowsPerPage,
        institute_id: selectedCollege || null,
        search_key: searchKey || "",
      };

      // only for tab === 1 (TrainerSelfAssessments)
      if (selectedTab === 0) {
        const res = await api.post("TrainerSelfAssessments", payload);
        if (res?.data?.status === "success") {
          setListData(res.data?.data || []);
          setCount(res.data?.count || 0);
        } else {
          console.error(res?.data?.message || "Failed to fetch");
        }
      } else {
        const res = await api.post("TrainerProctoredAssessments", payload);
        if (res?.data?.status === "success") {
          setListData(res.data?.data || []);
          setCount(res.data?.count || 0);
        } else {
          console.error(res?.data?.message || "Failed to fetch");
        }
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const trainerList = async (id) => {
    try {
      const payload = {
        institute_id: id || selectedCollege || 0,
      };
      const res = await api.post("/ListTrainersForFilter", payload);
      if (res?.data?.status === "success") {
        setTrainersList(res?.data?.data);
      }
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", "Failed to fetch institutes.");
    }
  };

  const instituteList = async () => {
    try {
      const res = await api.post("/ListInstituteNames");
      if (res?.data?.status === "success") {
        setColleges(res?.data?.data);
      }
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", "Failed to fetch institutes.");
    }
  };

  useEffect(() => {
    setPage(0);
    fetchData();
  }, [
    page,
    rowsPerPage,
    selectedTab,
    selectedCollege,
    selectedTrainer,
    searchKey,
  ]);

  useEffect(() => {
    instituteList();
    if (selectedCollege) {
      trainerList();
    }
  }, []);

  // === Pagination Handlers ===
  const handleChangePage = (event, newPage) => {
    localStorage.setItem("currentPage", newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    localStorage.setItem("rowsPerPage", event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // === Tab Change ===
  const handleTabChange = (event, newValue) => {
    localStorage.setItem("TabValue", newValue);
    setSelectedTab(newValue);
    setPage(0);
    setSearchKey("");
    setSelectedCollege("");
    setSelectedTrainer("");
  };

  // === Search Handler (optional filter) ===
  const handleSearch = (e) => {
    localStorage.setItem("searchvalue", e.target.value);
    setSearchKey(e.target.value);
  };

  return (
    <Box sx={{ minHeight: "100vh", p: 1 }}>
      {/* Back Button */}
      {dashboard && (
        <Grid
          item
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#1c97e3",
            gap: "6px",
            cursor: "pointer",
            width: "fit-content",
            mb: 2,
            transition: "0.2s",
            "&:hover": { color: "#0a73b1" },
          }}
          onClick={() => (
            window.history.back(), localStorage.removeItem("TabValue")
          )}
        >
          <ArrowBackIcon sx={{ fontSize: "18px" }} />
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", color: "inherit" }}
          >
            Back
          </Typography>
        </Grid>
      )}
      {/* === Header === */}
      <Grid
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #828487",
          pb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Box className="icon-box">
            <HistoryIcon sx={{ color: "#1976d2", fontSize: "28px" }} />
          </Box>
          <Typography sx={{ fontSize: { xs: 20, sm: 28 }, fontWeight: 700, color: "#0a0a0a" }}>
            Assessment History
          </Typography>
        </Box>

        <Box>
          <TextField
            value={searchKey}
            onChange={handleSearch}
            size="small"
            variant="outlined"
            placeholder="Search subject"
            className="custom-search-field"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Grid>
      <Box display="flex" gap={1} alignItems="center" mt={2}>
        {localStorage.getItem("role") !== "TRAINER" && (
          <Box display="flex" alignItems="center" gap={0.5}>
            <FilterAltIcon color="primary" />
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "primary.main",
                whiteSpace: "nowrap",
              }}
            >
              Filters
            </Typography>
          </Box>
        )}

        {/* Institute Filter (for Super Admin only) */}
        {localStorage.getItem("role") === "SUPER_ADMIN" && (
          <Autocomplete
            size="small"
            sx={{ minWidth: 250 }}
            options={colleges}
            getOptionLabel={(option) => option?.name || ""}
            value={
              colleges.find(
                (college) => college.institute_id === selectedCollege
              ) || null
            }
            onChange={(event, newValue) => {
              const selectedId = newValue ? newValue.institute_id : "";
              localStorage.setItem("Institute_Id_Filter", selectedId);
              setPage(0);
              setSelectedCollege(selectedId);
              setSelectedTrainer(""); // reset trainer when college changes
              trainerList(selectedId);
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                className="custom-search-field"
                {...params}
                placeholder="All Institutes"
                variant="outlined"
              />
            )}
          />
        )}

        {/* Trainer Filter */}
        {localStorage.getItem("role") !== "TRAINER" && (
          <Autocomplete
            size="small"
            sx={{ minWidth: 220 }}
            options={trainersList}
            value={
              trainersList.find(
                (trainer) => trainer.trainer_id === selectedTrainer
              ) || null
            }
            getOptionLabel={(option) => option?.name || ""}
            onChange={(event, newValue) => {
              const trainerId = newValue ? newValue.trainer_id : "";
              localStorage.setItem("Trainer_Id_Filter", trainerId);
              setPage(0);
              setSelectedTrainer(trainerId);
            }}
            disabled={selectedCollege === ""}
            renderInput={(params) => (
              <TextField
                size="small"
                className="custom-search-field"
                {...params}
                placeholder="All Trainers"
                variant="outlined"
                sx={{ width: 200 }}
                disabled={selectedCollege === ""}
              />
            )}
          />
        )}
      </Box>

      {/* === Tabs === */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="trainer tabs"
        >
          <Tab
            label="Self Assessments"
            sx={{ textTransform: "none", fontWeight: "bold", fontSize: 16 }}
          />
          <Tab
            label="Proctored Assessments"
            sx={{ textTransform: "none", fontWeight: "bold", fontSize: 16 }}
          />
        </Tabs>
      </Box>

      {/* === Table === */}
      <TableContainer
        component={Paper}
        sx={{
        }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#e8f0fe" }}>
            <TableRow>
              {headers.map((head, index) => (
                <TableCell key={index} align={head.align}>
                  <b>{head.label}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {loading ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  <TableLoader message="Fetching assessment history..." />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody className="tablebody">
              {listData?.length > 0 ? (
                listData.map((item, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    {localStorage.getItem("role") === "SUPER_ADMIN" && (
                      <TableCell>{item.institute_name || "-"}</TableCell>
                    )}

                    <TableCell>{item.category || "-"}</TableCell>
                    <TableCell>{item.level || "-"}</TableCell>
                    <TableCell align="center">
                      <Box
                        sx={{
                          display: "inline-block",
                          backgroundColor: "primary.main",
                          color: "white",
                          borderRadius: "12px",
                          px: 0.5,
                          py: 0.5,
                          fontSize: 13,
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: "40px",
                        }}
                      >
                        {item.no_of_students_completed || 0}/
                        {item.no_of_students_assigned || 0}
                      </Box>
                    </TableCell>
                    <TableCell>{item.trainer_name || "-"}</TableCell>
                    <TableCell>
                      {item.created_at
                        ? dayjs(item.created_at).format("DD-MM-YYYY hh:mm A")
                        : "-"}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip
                        title="View list of attendees"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "primary.main",
                              color: "white",
                              fontSize: 13,
                              fontWeight: 500,
                            },
                          },
                          arrow: {
                            sx: { color: "primary.main" },
                          },
                        }}
                      >
                        <IconButton
                          color="primary"
                          onClick={() =>
                            navigate("/examHistory", {
                              state: { assessmentId: item.assessment_id },
                            })
                          }
                        >
                          <PeopleOutlineOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={headers.length} align="center">
                    <TableNodata />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {/* === Pagination === */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default TrainerViewReview;
